import { createPortal } from "react-dom";
import { usePopupStore } from "store/usePopupStore";
import ConfirmPop from "./ConfirmPop";
import LoadingPop from "./LoadingPop";

export default function Popup() {
    const { confirmPop, loadingPop } = usePopupStore();

    return createPortal(
        <>
            {/* 알림 팝업 */}
            {confirmPop && <ConfirmPop />}

            {/* 로딩 팝업 */}
            {loadingPop && <LoadingPop />}
        </>,
        document.getElementById("modal-root")!,
    );
}
